<template>
  <div class="contact-info-section">
    <info
      :field="fields.field_one"
      @openPopup="$emit('openPopup', 'ARRIVAL')"
    />
  </div>
</template>

<script>
import Info from "/seu-frontend/components/section-fields/Info";
export default {
  name: "ContactInfoSection",
  components: {Info},
  props:{
    fields:{
      type:Object
    }
  },

}
</script>

<style lang="scss">
@import "ContactInfoSection.scss";
</style>
